import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { fifoService } from '../../services/fifoService';
import { toast } from 'react-toastify';
import PageLoader from '../../components/PageLoader';

const QcQueue = () => {
    const navigate = useNavigate();
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchRequests = async () => {
        setLoading(true);
        try {
            const data = await fifoService.getQcRequests();
            setRequests(data);
        } catch (error) {
            toast.error('ไม่สามารถโหลดข้อมูล QC ได้');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchRequests();
    }, []);

    // Group the flat per-serial rows into one row per document — clicking a
    // document opens QcRequestDetail, which shows items/serials individually.
    const documents = useMemo(() => {
        const byDoc = new Map();
        for (const req of requests) {
            if (!byDoc.has(req.document_id)) {
                byDoc.set(req.document_id, {
                    document_id: req.document_id,
                    customer_name: req.customer_name,
                    timestamp: req.timestamp,
                    itemCount: 0,
                    pendingCount: 0
                });
            }
            const doc = byDoc.get(req.document_id);
            doc.itemCount += 1;
            if (req.status !== 'Pass QC' && req.status !== 'Fail QC') {
                doc.pendingCount += 1;
            }
            if (new Date(req.timestamp) < new Date(doc.timestamp)) {
                doc.timestamp = req.timestamp;
            }
        }
        return Array.from(byDoc.values()).sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
    }, [requests]);

    return (
        <div>
            <h2 className="mb-4 theme-page-title"><i className="bi bi-shield-check me-2"></i>ตรวจสอบคุณภาพ (QC Queue)</h2>

            {loading ? <PageLoader message="กำลังโหลดข้อมูล..." /> : (
                <div className="theme-card">
                    <div className="theme-card-body">
                        {documents.length === 0 ? (
                            <div className="text-center py-5 text-muted">
                                <i className="bi bi-check2-circle display-4 mb-3 d-block opacity-50"></i>
                                ไม่มีรายการรอตรวจสอบ
                            </div>
                        ) : (
                            <div className="table-responsive">
                                <table className="table theme-table table-hover">
                                    <thead>
                                        <tr>
                                            <th>วันที่</th>
                                            <th>เลขที่เอกสาร</th>
                                            <th>ลูกค้า</th>
                                            <th>จำนวนเครื่อง</th>
                                            <th>สถานะ</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {documents.map((doc) => (
                                            <tr
                                                key={doc.document_id}
                                                role="button"
                                                onClick={() => navigate(`/qc-queue/${encodeURIComponent(doc.document_id)}`)}
                                                style={{ cursor: 'pointer' }}
                                            >
                                                <td>{new Date(doc.timestamp).toLocaleDateString('th-TH')}</td>
                                                <td>
                                                    <span className="fw-medium text-primary text-decoration-underline">
                                                        {doc.document_id}
                                                    </span>
                                                </td>
                                                <td>{doc.customer_name}</td>
                                                <td>{doc.itemCount} เครื่อง</td>
                                                <td>
                                                    {doc.pendingCount > 0 ? (
                                                        <span className="badge bg-info text-dark">
                                                            รอ QC ({doc.pendingCount})
                                                        </span>
                                                    ) : (
                                                        <span className="badge bg-success">
                                                            <i className="bi bi-check-lg me-1"></i>ตรวจครบแล้ว
                                                        </span>
                                                    )}
                                                </td>
                                                <td className="text-end">
                                                    <i className="bi bi-chevron-right text-muted"></i>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default QcQueue;
